import * as Sentry from '@sentry/react';
import { Routes } from 'react-router';

export default Sentry.withSentryReactRouterV6Routing(Routes);
